(() => {
  const isHome = document.body.classList.contains('natura-home');
  const isProduct = document.body.classList.contains('natura-product-page');

  const labels = {
    el: 'Χονδρική & εκπτώσεις ποσότητας',
    en: 'Wholesale & quantity discounts',
    fr: 'Tarifs de gros et remises par quantité',
    nl: 'Groothandelsprijzen en staffelkorting',
    cs: 'Velkoobchodní ceny a množstevní slevy',
    de: 'Großhandel & Mengenrabatte',
    es: 'Precios mayoristas y descuentos por cantidad'
  };

  const reviewBadgeLabels = {
    el: 'Πιστοποιημένες κριτικές πελατών',
    en: 'Verified customer reviews',
    fr: 'Avis clients vérifiés',
    nl: 'Geverifieerde klantbeoordelingen',
    cs: 'Ověřené recenze zákazníků',
    de: 'Verifizierte Kundenbewertungen',
    es: 'Reseñas verificadas de clientes'
  };

  const reviewLinkLabels = {
    el: 'Δείτε όλα τα προϊόντα και τις κριτικές',
    en: 'View all products and reviews',
    fr: 'Voir tous les produits et avis',
    nl: 'Bekijk alle producten en beoordelingen',
    cs: 'Zobrazit všechny produkty a recenze',
    de: 'Alle Produkte und Bewertungen ansehen',
    es: 'Ver todos los productos y reseñas'
  };

  const optimizeReviewWidgets = () => {
    if (!isHome && !isProduct) return;

    const locale = document.documentElement.lang.split('-')[0];
    const badgeAlt = reviewBadgeLabels[locale] || reviewBadgeLabels.en;
    const linkLabel = reviewLinkLabels[locale] || reviewLinkLabels.en;

    document.querySelectorAll('.jdgm-widget img, .jdgm-carousel-wrapper img, img[src*="judge.me"]').forEach((image) => {
      const source = image.currentSrc || image.src || image.dataset.src || '';

      if (/judge\.me/i.test(source) && /verified|badge/i.test(source)) {
        image.alt = badgeAlt;
        image.setAttribute('width', '71');
        image.setAttribute('height', '71');
        image.decoding = 'async';
      } else if (/judge\.me/i.test(source) && /logo/i.test(source)) {
        if (!image.alt) image.alt = 'Judge.me';
        image.setAttribute('width', '125');
        image.setAttribute('height', '24');
        image.decoding = 'async';
      }
    });

    document
      .querySelectorAll('.jdgm-carousel-item__product-image img, img.jdgm-carousel-item__product-image, .jdgm-carousel-item img[data-src*="70x70"]')
      .forEach((image) => {
        image.setAttribute('width', '70');
        image.setAttribute('height', '70');
        image.decoding = 'async';
      });

    document.querySelectorAll('.jdgm-widget > a[href^="javascript:"]').forEach((link) => {
      const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      link.href = `${root}collections/all-products`;
      link.setAttribute('aria-label', linkLabel);
    });
  };

  const syncQuantityTables = () => {
    if (!isProduct) return;

    document
      .querySelectorAll('.product__info-container .price > .clay-quantity-grid-table-container')
      .forEach((grid) => {
        const info = grid.closest('.product__info-container');
        const form = info && info.querySelector('.product-form');
        if (!info || !form) return;

        let anchor = form;
        while (anchor.parentElement && anchor.parentElement !== info) {
          anchor = anchor.parentElement;
        }
        if (anchor.parentElement !== info) return;

        let details = info.querySelector('.natura-volume-pricing');
        if (!details) {
          details = document.createElement('details');
          const summary = document.createElement('summary');
          const locale = document.documentElement.lang.split('-')[0];

          details.className = 'natura-volume-pricing';
          summary.className = 'natura-volume-pricing__summary';
          summary.textContent = labels[locale] || labels.en;
          details.appendChild(summary);
          anchor.insertAdjacentElement('afterend', details);
        }

        const signature = grid.textContent.replace(/\s+/g, ' ').trim();
        if (details.dataset.signature === signature) return;

        const clone = grid.cloneNode(true);
        const current = details.querySelector('.clay-quantity-grid-table-container');
        clone.removeAttribute('id');

        if (current) {
          details.replaceChild(clone, current);
        } else {
          details.appendChild(clone);
        }

        details.dataset.signature = signature;
        document.documentElement.dataset.naturaQuantityPricing = 'ready';
      });
  };

  const startPurchaseShortcut = () => {
    const bar = document.querySelector('[data-natura-purchase-shortcut]');
    if (!bar || bar.dataset.ready || !('IntersectionObserver' in window)) return;
    const info = document.getElementById(`ProductInfo-${bar.dataset.naturaPurchaseShortcut}`);
    const controls = info && info.querySelector('.product-form__buttons');
    if (!controls) return;
    bar.dataset.ready = 'true';
    const mobile = window.matchMedia('(max-width: 749px)');
    let passedControls = false;
    const refresh = () => {
      const visible = mobile.matches && passedControls;
      bar.hidden = !visible;
      document.body.classList.toggle('natura-purchase-shortcut-visible', visible);
    };
    const observer = new IntersectionObserver(([entry]) => {
      passedControls = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      refresh();
    });
    observer.observe(controls);
    mobile.addEventListener('change', refresh);
    bar.querySelector('a').addEventListener('click', () => {
      info.setAttribute('tabindex', '-1');
      info.focus({ preventScroll: true });
    });
  };

  const start = () => {
    const info = document.querySelector('.product__info-container');
    optimizeReviewWidgets();
    syncQuantityTables();
    startPurchaseShortcut();
    if (!info || info.dataset.naturaQuantityObserver === 'ready') return;

    let quantityFramePending = false;
    const observer = new MutationObserver(() => {
      if (quantityFramePending) return;
      quantityFramePending = true;
      window.requestAnimationFrame(() => {
        quantityFramePending = false;
        syncQuantityTables();
      });
    });
    observer.observe(info, { childList: true, subtree: true });
    info.dataset.naturaQuantityObserver = 'ready';
  };

  document.documentElement.dataset.naturaConversion = 'loaded';

  const scheduleStart = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(start, { timeout: 1200 });
    } else {
      window.setTimeout(start, 120);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleStart, { once: true });
  } else {
    scheduleStart();
  }

  if (isProduct) {
    window.setTimeout(syncQuantityTables, 1200);
    window.setTimeout(syncQuantityTables, 2600);
  }
  if (isHome || isProduct) {
    window.setTimeout(optimizeReviewWidgets, 3200);
    document.addEventListener('shopify:section:load', scheduleStart);
  }
})();

